import { render, staticRenderFns } from "./AtPopover.vue?vue&type=template&id=c222e654&scoped=true&"
import script from "./AtPopover.vue?vue&type=script&lang=js&"
export * from "./AtPopover.vue?vue&type=script&lang=js&"
import style0 from "./AtPopover.vue?vue&type=style&index=0&id=c222e654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c222e654",
  null
  
)

export default component.exports